/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';

import React, { useEffect, useState } from 'react';

export interface AgentationWrapperProps {
  endpoint?: string;
}

interface AgentationComponentProps {
  endpoint: string;
}

type AgentationComponent = React.ComponentType<AgentationComponentProps>;

export default function AgentationWrapper({
  endpoint = 'http://localhost:4747',
}: AgentationWrapperProps) {
  const [Agentation, setAgentation] = useState<AgentationComponent | null>(
    null,
  );

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      import('agentation')
        .then((module) => {
          setAgentation(() => module.Agentation);
        })
        .catch((error) => {
          console.warn('Agentation failed to load in development:', error);
        });
    }
  }, []);

  // Return early if not in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // If in dev but the file is still downloading asynchronously, wait
  if (!Agentation) {
    return null;
  }

  return <Agentation endpoint={endpoint} />;
}
